import clsx from 'clsx';
import React from 'react';

import { ColorScheme } from '~/design-tokens/themes/themes';

import styles from './Loading.module.scss';

interface LoadingProps {
  className?: string;
  colorScheme?: ColorScheme;
}

export const Loading = ({
  className,
  colorScheme = ColorScheme.Dark,
}: LoadingProps) => (
  <div
    className={clsx(styles.loader, className)}
    data-testid="loading-view"
  >
    <div className={styles.innerBox}>
      <div className={styles.logoBox}>
        <img
          data-testid="loading-logo"
          src={`/app/static/images/brand/logo-${colorScheme}.svg`}
          alt="logo"
        />
      </div>
      <div className={styles.progressBar}>
        <div className={styles.progressBarMeter} />
      </div>
    </div>
  </div>
);
